// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"d--z"};